// extracted by mini-css-extract-plugin
export default {"Menu":"bgs_a bhh_h","Menu__offsetParent":"bgs_b bhh_bj","Menu__trigger--shadowed":"bgs_c"};